import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import Loader from '../components/block-components/loader/loader';
import { routeConstants } from '../services/constants/route-constants';
import ProctedRoutes from './protected-routes';
import { apiLinks } from '../config/environment';


const AdminRoutes = lazy(() => import("./admin-route"));
const VendorRoutes = lazy(() => import("./vendor-route"));
const ConsumerRoutes = lazy(() => import("./consumer-route"));
const FinancialInstitutionRoutes = lazy(() => import("./financial-institution-route"));
const StudentRoutes = lazy(() => import("./student-route"));
const ManagerRoutes = lazy(() => import("./manager-route"));
const SchoolManagerRoutes = lazy(() => import("./school-manager-route"));
const SchoolOfficialRoutes = lazy(() => import("./school-official-route"));
const FinanceManagerRoutes = lazy(() => import("./finance-manager-route"));
const HomeRoutes = lazy(() => import("./home-route"));
const ComponentCanvas = lazy(() => import("../pages/admin/component-canvas/component-canvas"));

function BaseRoute() {
  return (
    <Router>
      <Suspense fallback={<Loader/>}>
        <Routes>
          <Route element={<ProctedRoutes/>}>
            <Route path={`${routeConstants.admin}/*`} element={<AdminRoutes/>}></Route>
            <Route path={`${routeConstants.vendor}/*`} element={<VendorRoutes/>}></Route>
            {apiLinks().awsKey === 'development/' && <Route path={`${routeConstants.consumers}/*`} element={<ConsumerRoutes/>}></Route>}
            <Route path={`${routeConstants.financial_institution}/*`} element={<FinancialInstitutionRoutes/>}></Route>
            <Route path={`${routeConstants.manager}/*`} element={<ManagerRoutes/>}></Route>
            <Route path={`${routeConstants.school_manager}/*`} element={<SchoolManagerRoutes/>}></Route>
            <Route path={`${routeConstants.school_official}/*`} element={<SchoolOfficialRoutes/>}></Route>
            <Route path={`${routeConstants.finance_manager}/*`} element={<FinanceManagerRoutes/>}></Route>
            <Route path={`${routeConstants.student}/*`} element={<StudentRoutes/>}></Route>
          </Route>
          <Route path={routeConstants.componentCanvas} element={<ComponentCanvas/>}></Route>
          <Route path={'*'} element={<HomeRoutes/>}></Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default BaseRoute;
